/*!
 * Copyright (c) Microsoft. All rights reserved.
 * Licensed under the MIT license. See LICENSE file in the project.
 */

import styled from 'styled-components'

export const ButtonWrapper = styled.div`
	display: flex;
	justify-content: flex-end;
	gap: 1rem;
`

export const FilterContainer = styled.div`
	display: flex;
	gap: 1rem;
	margin-bottom: 1rem;
`
